var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRightFilled = function SvgChevronRightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.682.47a.75.75 0 0 1 .163-.243.75.75 0 0 1 1.074 0l5.127 4.982a1.123 1.123 0 0 1 0 1.589l-5.127 4.978a.75.75 0 0 1-1.074 0 .748.748 0 0 1-.218-.528L2.625.757c0-.099.02-.196.057-.287Z"
  })));
};
export default SvgChevronRightFilled;